var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',[_c('LoadingModal',{attrs:{"show":_vm.response.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }